module.exports = __webpack_public_path__ + "static/media/xbox.5acdd3d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xbox.svg
// module id = 117
// module chunks = 0